import { FieldErrors, useFormContext } from 'react-hook-form'
import { AuftragOption, AuftragOptionen, BefehlFormField } from '../Generic'
import { Betriebsstellenart } from '../../../types'
import { BetriebsstelleField } from '../../form'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Befehl31FormData } from './schema'

export interface Feld31_11_12FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
  errors?: FieldErrors
}

export default function Feld31_11_12Form({
  readOnly,
  'data-testid': testId,
  errors,
  activateEmptyFieldWarnings = false
}: Readonly<Feld31_11_12FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const formContext = useFormContext<Befehl31FormData>()
  const { control, formState, watch } = formContext

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const selector = watch('auftrag_31_10.feld31_11_12.selector')

  return (
    <BefehlFormField
      name="auftrag_31_10.feld31_11_12.selector"
      control={control}
      label=""
      readOnly={readOnly}
      activateEmptyWarning={activateEmptyFieldWarnings}
      useTextDisplayInReadOnly={false}
      data-testid={`${testId}-selector`}
      render={({ field, isDisabled }) => (
        <AuftragOptionen
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          readOnly={readOnly}
          disabled={isDisabled}
          errors={fieldErrors}
          data-testid={`${testId}-selector-options`}
        >
          <AuftragOption
            value={Betriebsstellenart.Bf}
            label={t('befehle.31.label.feld31_11')}
            data-testid={`${testId}-selector-options-bf`}
          >
            <BefehlFormField
              name={'auftrag_31_10.feld31_11_12.name'}
              label={t('befehle.31.text.bf')}
              control={control}
              readOnly={readOnly}
              activateEmptyWarning={activateEmptyFieldWarnings}
              data-testid={`${testId}-feld-31-11`}
              render={({ field: zmField }) => (
                <BetriebsstelleField
                  {...zmField}
                  label={t('befehle.31.text.bf')}
                  variant="solid"
                  className="w-full"
                  data-testid={`${testId}-feld-31-11-inner`}
                  errors={fieldErrors}
                  typ={selector}
                />
              )}
            />
          </AuftragOption>
          <AuftragOption
            value={Betriebsstellenart.Bft}
            label={t('befehle.31.label.feld31_12')}
            data-testid={`${testId}-selector-options-bft`}
          >
            <BefehlFormField
              name="auftrag_31_10.feld31_11_12.name"
              label={t('befehle.31.text.bft')}
              control={control}
              readOnly={readOnly}
              activateEmptyWarning={activateEmptyFieldWarnings}
              data-testid={`${testId}-feld-31-12`}
              render={({ field: zmField }) => (
                <BetriebsstelleField
                  {...zmField}
                  label={t('befehle.31.text.bft')}
                  variant="solid"
                  className="w-full"
                  data-testid={`${testId}-feld-31-12-inner`}
                  errors={fieldErrors}
                  typ={selector}
                />
              )}
            />
          </AuftragOption>
        </AuftragOptionen>
      )}
    />
  )
}
